<template>
  <component :is="meetingDisconnectedComponent"></component>
</template>

<script>
export default {
  name: 'MeetingDisconnected',
  data () {
    return {
    }
  },
  components: {
    agentDisconnectedComponent: () => import('./MeetingAgentDisconnected'),
    participantDisconnectedComponent: () => import('./MeetingParticipantDisconnected')
  },
  computed: {
    meetingDisconnectedComponent () {
      return this.$store.getters.getUser !== false || this.$store.getters.getMeetingDisconnectedAs === 'agent' ? 'agentDisconnectedComponent' : 'participantDisconnectedComponent'
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
